/* Ricapet — comportamento do tema (sem jQuery). Motion entra por cima, nunca é necessário para funcionar. */

const R = window.Ricapet || {};
const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const EASE = [0.16, 1, 0.3, 1];

let M = null; // motion.dev, carregado sob demanda
const motionReady = reduceMotion
  ? Promise.resolve(null)
  : import('https://cdn.jsdelivr.net/npm/motion@13.4.6/+esm').then((m) => (M = m)).catch(() => null);

function money(cents) {
  const v = (Number(cents) || 0) / 100;
  return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

/* ---------------- Cabeçalho ---------------- */
const headerWrap = $('[data-header]');
if (headerWrap) {
  // Some ao descer, volta ao subir. Fica visível perto do topo e com menu, busca ou carrinho abertos.
  let lastY = window.scrollY;
  const onScroll = () => {
    const y = window.scrollY;
    headerWrap.classList.toggle('is-scrolled', y > 8);
    const ocupado = document.body.classList.contains('is-locked') || headerWrap.contains(document.activeElement);
    const alvo = headerWrap.closest('.section-header') || headerWrap;
    if (y < 140 || ocupado) alvo.classList.remove('is-hidden');
    else if (y > lastY + 6) alvo.classList.add('is-hidden');
    else if (y < lastY - 6) alvo.classList.remove('is-hidden');
    if (Math.abs(y - lastY) > 6) lastY = y;
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

/* ---------------- Gavetas ---------------- */
let lastFocus = null;
function openDrawer(el) {
  if (!el) return;
  lastFocus = document.activeElement;
  el.classList.add('is-open');
  el.setAttribute('aria-hidden', 'false');
  document.body.classList.add('is-locked');
  $$(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
  const focusable = $('button, a[href], input', $('.drawer__panel', el) || el);
  setTimeout(() => focusable && focusable.focus({ preventScroll: true }), 60);
}
function closeDrawer(el) {
  if (!el) return;
  el.classList.remove('is-open');
  el.setAttribute('aria-hidden', 'true');
  if (!$('.drawer.is-open, .search-overlay.is-open')) document.body.classList.remove('is-locked');
  $$(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
  if (lastFocus) lastFocus.focus({ preventScroll: true });
}
document.addEventListener('click', (e) => {
  const opener = e.target.closest('[data-drawer-open]');
  if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.dataset.drawerOpen)); return; }
  const closer = e.target.closest('[data-drawer-close]');
  if (closer) { closeDrawer(closer.closest('[data-drawer]')); return; }
  const cartOpen = e.target.closest('[data-cart-open]');
  if (cartOpen && document.body.classList.contains('template-cart') === false) {
    e.preventDefault();
    openDrawer($('[data-cart-drawer]'));
  }
});
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  $$('.drawer.is-open').forEach(closeDrawer);
  closeSearch();
});

/* ---------------- Busca ---------------- */
const searchEl = $('[data-search-overlay]');
const searchInput = $('[data-search-input]');
const searchResults = $('[data-search-results]');
const searchDefault = searchResults ? searchResults.innerHTML : '';
function openSearch() {
  if (!searchEl) return;
  lastFocus = document.activeElement;
  searchEl.classList.add('is-open');
  searchEl.setAttribute('aria-hidden', 'false');
  document.body.classList.add('is-locked');
  setTimeout(() => searchInput && searchInput.focus(), 80);
}
function closeSearch() {
  if (!searchEl || !searchEl.classList.contains('is-open')) return;
  searchEl.classList.remove('is-open');
  searchEl.setAttribute('aria-hidden', 'true');
  if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
  if (lastFocus) lastFocus.focus({ preventScroll: true });
}
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
  if (e.target.closest('[data-search-close]')) closeSearch();
});
if (searchInput) {
  let t; let ctrl;
  searchInput.addEventListener('input', () => {
    clearTimeout(t);
    const q = searchInput.value.trim();
    if (q.length < 2) { searchResults.innerHTML = searchDefault; return; }
    t = setTimeout(async () => {
      ctrl && ctrl.abort();
      ctrl = new AbortController();
      try {
        const url = `${R.routes.predictive}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last`;
        const html = await (await fetch(url, { signal: ctrl.signal })).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('.shopify-section') || doc.body;
        searchResults.innerHTML = inner.innerHTML;
        if (M) M.animate($$('.search-hit', searchResults), { opacity: [0, 1], y: [10, 0] }, { delay: M.stagger(0.03), duration: 0.35, ease: EASE });
      } catch (err) { /* digitação rápida aborta a anterior */ }
    }, 220);
  });
}

/* Busca do cabeçalho: sugestões numa caixa logo abaixo do campo */
$$('[data-hsearch]').forEach((form) => {
  const input = $('[data-hsearch-input]', form);
  const drop = $('[data-hsearch-results]', form);
  let t; let ctrl;
  const close = () => { drop.hidden = true; };
  input.addEventListener('input', () => {
    clearTimeout(t);
    const q = input.value.trim();
    if (q.length < 2) { close(); return; }
    t = setTimeout(async () => {
      ctrl && ctrl.abort();
      ctrl = new AbortController();
      try {
        const url = `${R.routes.predictive}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last`;
        const html = await (await fetch(url, { signal: ctrl.signal })).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('.shopify-section') || doc.body;
        drop.innerHTML = inner.innerHTML;
        drop.hidden = !drop.innerHTML.trim();
        if (M && !drop.hidden) M.animate(drop, { opacity: [0, 1], y: [-6, 0] }, { duration: 0.25, ease: EASE });
      } catch (err) { /* digitação rápida aborta a anterior */ }
    }, 220);
  });
  input.addEventListener('focus', () => { if (drop.innerHTML.trim() && input.value.trim().length > 1) drop.hidden = false; });
  document.addEventListener('click', (e) => { if (!form.contains(e.target)) close(); });
  input.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); input.blur(); } });
});

/* ---------------- Carrinho ---------------- */
const Cart = {
  async refresh(html) {
    const drawer = $('[data-cart-drawer]');
    if (html && drawer) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer] .drawer__panel');
      const panel = $('.drawer__panel', drawer);
      if (fresh && panel) panel.innerHTML = fresh.innerHTML;
    }
    const cart = await (await fetch(`${R.routes.cart}.js`, { headers: { Accept: 'application/json' } })).json();
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.dataset.count = cart.item_count;
      el.dataset.cartCount = cart.item_count;
      if (M && cart.item_count > 0) M.animate(el, { scale: [1.5, 1] }, { type: 'spring', stiffness: 500, damping: 14 });
    });
    $$('[data-cart-subtotal]').forEach((el) => { el.textContent = money(cart.total_price); });
    $$('[data-cart-open]').forEach((a) => a.setAttribute('aria-label', `Carrinho, ${cart.item_count} ${cart.item_count === 1 ? 'item' : 'itens'}`));
    return cart;
  },
  async add(items) {
    const res = await fetch(`${R.routes.cartAdd}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: 'cart-drawer', sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Não foi possível adicionar.');
    await Cart.refresh(data.sections && data.sections['cart-drawer']);
    return data;
  },
  async change(key, quantity) {
    const res = await fetch(`${R.routes.cartChange}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Não foi possível atualizar.');
    if (document.body.classList.contains('template-cart')) { window.location.reload(); return data; }
    await Cart.refresh(data.sections && data.sections['cart-drawer']);
    return data;
  }
};
window.RicapetCart = Cart;

function toast(msg) {
  let el = $('[data-toast]');
  if (!el) {
    el = document.createElement('div');
    el.dataset.toast = '';
    el.setAttribute('role', 'status');
    el.style.cssText = 'position:fixed;left:50%;bottom:24px;translate:-50% 0;z-index:90;background:#1d0f3a;color:#fff;padding:12px 20px;border-radius:999px;font-weight:700;box-shadow:0 20px 40px -20px rgba(0,0,0,.6);max-width:90vw;text-align:center';
    document.body.appendChild(el);
  }
  el.textContent = msg;
  el.hidden = false;
  clearTimeout(el._t);
  el._t = setTimeout(() => { el.hidden = true; }, 3600);
}

function flyToCart(imgSrc, fromEl) {
  const target = $('[data-cart-open]');
  if (!M || !imgSrc || !target || !fromEl) return;
  const a = fromEl.getBoundingClientRect();
  const b = target.getBoundingClientRect();
  const ghost = document.createElement('img');
  ghost.src = imgSrc;
  ghost.alt = '';
  ghost.style.cssText = `position:fixed;z-index:95;left:${a.left + a.width / 2 - 36}px;top:${a.top + a.height / 2 - 36}px;width:72px;height:72px;object-fit:cover;border-radius:50%;box-shadow:0 14px 30px -10px rgba(42,22,80,.6);pointer-events:none`;
  document.body.appendChild(ghost);
  const dx = b.left + b.width / 2 - (a.left + a.width / 2);
  const dy = b.top + b.height / 2 - (a.top + a.height / 2);
  M.animate(ghost, { x: [0, dx * 0.5, dx], y: [0, dy - 80, dy], scale: [1, 0.9, 0.25], opacity: [1, 1, 0.2] }, { duration: 0.75, ease: EASE })
    .then(() => ghost.remove());
}

document.addEventListener('click', async (e) => {
  const quick = e.target.closest('[data-quick-add]');
  if (quick) {
    e.preventDefault();
    quick.classList.add('is-loading');
    try {
      const card = quick.closest('[data-product-card], .upsell');
      const img = quick.dataset.img || (card && $('img', card) && $('img', card).currentSrc);
      flyToCart(img, quick);
      await Cart.add([{ id: Number(quick.dataset.quickAdd), quantity: 1 }]);
      setTimeout(() => openDrawer($('[data-cart-drawer]')), M ? 420 : 0);
    } catch (err) { toast(err.message); }
    quick.classList.remove('is-loading');
    return;
  }
  const qtyBtn = e.target.closest('[data-qty-change]');
  if (qtyBtn) {
    e.preventDefault();
    const line = qtyBtn.closest('.citem');
    if (line) line.style.opacity = '.5';
    try { await Cart.change(qtyBtn.dataset.qtyChange, Math.max(0, Number(qtyBtn.dataset.qty))); }
    catch (err) { toast(err.message); if (line) line.style.opacity = ''; }
    return;
  }
  const copy = e.target.closest('[data-copy]');
  if (copy) {
    try { await navigator.clipboard.writeText(copy.dataset.copy); copy.textContent = 'Copiado!'; }
    catch (err) { copy.textContent = copy.dataset.copy; }
    setTimeout(() => { copy.textContent = 'Copiar'; }, 2200);
    return;
  }
  const checkoutBtn = e.target.closest('[data-checkout]');
  if (checkoutBtn) { e.preventDefault(); goCheckout(checkoutBtn); }
});

document.addEventListener('change', async (e) => {
  const input = e.target.closest('[data-qty-input]');
  if (!input) return;
  try { await Cart.change(input.dataset.qtyInput, Math.max(0, Number(input.value) || 0)); }
  catch (err) { toast(err.message); }
});

/* ---------------- Checkout Yampi ---------------- */
async function goCheckout(btn) {
  if (btn) btn.classList.add('is-loading');
  const fallback = () => { window.location.href = `${R.routes.root}checkout`.replace('//checkout', '/checkout'); };
  try {
    const cart = await (await fetch(`${R.routes.cart}.json`, { headers: { Accept: 'application/json' } })).json();
    const res = await fetch('https://api.dooki.com.br/v2/public/shopify/cart', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ shop: window.location.host, shopify_internal_domain: R.shopDomain, cart_payload: cart })
    });
    const data = await res.json();
    if (data && data.checkout_direct_url) {
      const url = typeof window.ymp_getUrlWithUtms === 'function' ? window.ymp_getUrlWithUtms(data.checkout_direct_url) : data.checkout_direct_url;
      window.location.href = url;
      return;
    }
    fallback();
  } catch (err) {
    window.location.href = R.routes.cart;
  }
}
window.RicapetCheckout = goCheckout;

/* ---------------- Página de produto ---------------- */
function initProduct(section) {
  const jsonEl = $('[data-product-json]', section.parentElement) || $('[data-product-json]');
  if (!jsonEl) return;
  const data = JSON.parse(jsonEl.textContent);
  const form = $('[data-product-form]', section);
  const idInput = $('[data-variant-input]', section);
  const addBtn = $('[data-add-btn]', section);
  const addLabel = $('[data-add-label]', section);
  const buyNow = $('[data-buy-now]', section);
  const errorEl = $('[data-form-error]', section);
  const qtyField = $('[data-qty-field]', section);
  const sticky = $('[data-sticky-atc]');
  const stickyBtn = sticky && $('[data-sticky-add]', sticky);
  const gallery = initGallery($('[data-gallery]', section));
  let current = data.variants.find((v) => v.id === Number(idInput.value)) || data.variants[0];

  function selectedOptions() {
    return $$('fieldset.opt', section).map((fs) => {
      const c = $('input:checked', fs);
      return c ? c.value : null;
    });
  }
  function markAvailability() {
    const sel = selectedOptions();
    $$('fieldset.opt', section).forEach((fs, idx) => {
      $$('input[data-option]', fs).forEach((input) => {
        const probe = sel.slice();
        probe[idx] = input.value;
        const ok = data.variants.some((v) => v.available && v.options.every((o, i) => probe[i] == null || o === probe[i]));
        input.classList.toggle('is-unavailable', !ok);
      });
    });
  }
  function render(v) {
    current = v;
    idInput.value = v ? v.id : '';
    const available = !!(v && v.available);
    [addBtn, buyNow, stickyBtn].forEach((b) => b && (b.disabled = !available));
    if (addLabel) addLabel.textContent = !v ? 'Indisponível' : available ? 'Adicionar ao carrinho' : 'Esgotado';
    if (stickyBtn) $('span', stickyBtn).textContent = !v ? 'Indisponível' : available ? 'Adicionar ao carrinho' : 'Esgotado';
    if (!v) return;
    const now = $('[data-price-now]', section);
    if (now) now.textContent = money(v.price);
    let was = $('[data-price-was]', section);
    if (v.compare_at_price > v.price) {
      if (!was && now) { was = document.createElement('s'); was.className = 'price__was'; was.dataset.priceWas = ''; now.after(was); }
      if (was) was.textContent = money(v.compare_at_price);
    } else if (was) was.remove();
    const save = $('[data-save]', section);
    if (save) { save.hidden = !(v.compare_at_price > v.price); save.textContent = `Economize ${money(v.compare_at_price - v.price)}`; }
    const off = $('[data-badge-off]', section);
    if (off) { const p = v.compare_at_price > v.price ? Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100) : 0; off.hidden = p < 5; off.textContent = `-${p}%`; }
    let n = Number(R.installments) || 1;
    if (R.installmentsMin > 0) n = Math.min(n, Math.floor(v.price / R.installmentsMin));
    const inst = $('[data-inst]', section);
    if (inst) { inst.hidden = n < 2; $('[data-inst-n]', inst).textContent = n; $('[data-inst-v]', inst).textContent = money(Math.floor(v.price / Math.max(n, 1))); }
    const sp = $('[data-sticky-price]');
    if (sp) sp.textContent = money(v.price);
    const sku = $('[data-sku]', section);
    if (sku) sku.textContent = v.sku ? `Cód.: ${v.sku}` : '';
    const stock = $('[data-stock]', section);
    if (stock) stock.hidden = available;
    renderTiers(v);
    if (v.media_id && gallery) gallery.goToMedia(v.media_id);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url);
  }

  // Leve mais, pague menos: faixas de quantidade
  const tiers = $('[data-tiers]', section);
  function renderTiers(v) {
    if (!tiers || !v) return;
    const pct = { 1: 0, 2: Number(tiers.dataset.p2) || 0, 3: Number(tiers.dataset.p3) || 0 };
    const base = v.compare_at_price > v.price ? v.compare_at_price : v.price;
    $$('[data-tier]', tiers).forEach((el) => {
      const q = Number(el.dataset.tier);
      const bruto = v.price * q;
      const total = bruto - Math.round((bruto * pct[q]) / 100);
      const cmp = base * q;
      const eco = cmp - total;
      const ecoPct = cmp > 0 ? Math.round((eco * 100) / cmp) : 0;
      $('[data-tier-price]', el).textContent = money(total);
      const was = $('[data-tier-was]', el);
      was.textContent = money(cmp); was.hidden = eco <= 0;
      const save = $('[data-tier-save]', el);
      save.textContent = `Economize ${money(eco)}`; save.hidden = eco <= 0;
      $('[data-tier-sub]', el).textContent = q === 1 ? 'Preço normal' : ecoPct > 0 ? `Você economiza ${ecoPct}%` : `${q} unidades`;
    });
  }
  function syncTier() {
    if (!tiers || !qtyField) return;
    const q = Math.min(3, Math.max(1, Number(qtyField.value) || 1));
    const input = $(`[data-tier="${q}"] [data-tier-input]`, tiers);
    if (input) input.checked = true;
  }
  if (tiers) {
    tiers.addEventListener('change', (e) => {
      const input = e.target.closest('[data-tier-input]');
      if (!input || !qtyField) return;
      qtyField.value = input.value;
      if (M) M.animate(input.closest('[data-tier]'), { scale: [0.98, 1] }, { duration: 0.3, ease: EASE });
    });
    if (qtyField) qtyField.addEventListener('input', syncTier);
  }

  section.addEventListener('change', (e) => {
    const opt = e.target.closest('[data-option]');
    if (!opt) return;
    const fs = opt.closest('fieldset');
    const label = fs && $('[data-option-label]', fs);
    if (label) label.textContent = opt.value;
    const sel = selectedOptions();
    const v = data.variants.find((x) => x.options.every((o, i) => o === sel[i]));
    render(v || null);
    markAvailability();
  });
  markAvailability();

  section.addEventListener('click', (e) => {
    const step = e.target.closest('[data-step]');
    if (step && qtyField) { qtyField.value = Math.max(1, (Number(qtyField.value) || 1) + Number(step.dataset.step)); syncTier(); }
  });

  async function addCurrent(btn) {
    if (!current || !current.available) return false;
    errorEl.hidden = true;
    btn.classList.add('is-loading');
    try {
      const img = $('.gallery__slide img', section);
      flyToCart(img && img.currentSrc, btn);
      await Cart.add([{ id: current.id, quantity: Math.max(1, Number(qtyField && qtyField.value) || 1) }]);
      return true;
    } catch (err) {
      errorEl.textContent = err.message;
      errorEl.hidden = false;
      return false;
    } finally { btn.classList.remove('is-loading'); }
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (await addCurrent(addBtn)) setTimeout(() => openDrawer($('[data-cart-drawer]')), M ? 420 : 0);
  });
  if (buyNow) buyNow.addEventListener('click', async () => { if (await addCurrent(buyNow)) goCheckout(buyNow); });
  if (stickyBtn) stickyBtn.addEventListener('click', async () => { if (await addCurrent(stickyBtn)) setTimeout(() => openDrawer($('[data-cart-drawer]')), M ? 420 : 0); });

  if (sticky && addBtn && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      stickyBtn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('has-sticky-atc', show);
    });
    io.observe(addBtn);
  }
}

function initGallery(root) {
  if (!root) return null;
  const track = $('[data-gallery-track]', root);
  const thumbs = $$('[data-gallery-thumb]', root);
  const counter = $('[data-gallery-counter]', root);
  const slides = $$('.gallery__slide', track);
  const goTo = (i, smooth = true) => {
    const s = slides[i];
    if (!s) return;
    track.scrollTo({ left: s.offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
  };
  const sync = () => {
    const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
    if (counter) counter.textContent = `${i + 1} / ${slides.length}`;
    const active = thumbs[i];
    if (active) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  };
  let raf;
  track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
  thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.galleryThumb))));
  track.addEventListener('keydown', (e) => {
    const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    if (e.key === 'ArrowRight') goTo(Math.min(slides.length - 1, i + 1));
    if (e.key === 'ArrowLeft') goTo(Math.max(0, i - 1));
  });
  // Miniaturas: avisa que tem mais fotos fora da área visível
  const rail = $('[data-thumbs-rail]', root);
  const list = rail && $('[data-thumbs]', rail);
  const more = rail && $('[data-thumbs-more]', rail);
  if (list && more) {
    const vertical = () => getComputedStyle(list).flexDirection === 'column';
    const update = () => {
      const left = vertical() ? list.scrollHeight - list.clientHeight - list.scrollTop : list.scrollWidth - list.clientWidth - list.scrollLeft;
      const hasMore = left > 4;
      rail.classList.toggle('has-more', hasMore);
      more.hidden = !hasMore;
    };
    more.addEventListener('click', () => {
      const step = vertical() ? list.clientHeight * 0.8 : list.clientWidth * 0.8;
      list.scrollBy(vertical() ? { top: step, behavior: 'smooth' } : { left: step, behavior: 'smooth' });
    });
    list.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(list);
    update();
  }
  initLightbox(root, slides, track);
  return { goToMedia(id) { const i = slides.findIndex((s) => Number(s.dataset.mediaId) === Number(id)); if (i > -1) goTo(i); } };
}

// Ampliação das fotos: abre em tela cheia, navega e aproxima no clique
function initLightbox(root, slides, track) {
  const box = $('[data-lbox]');
  const fotos = slides.filter((s) => s.dataset.zoomSrc);
  if (!box || !fotos.length) return;
  const img = $('[data-lbox-img]', box);
  const stage = $('[data-lbox-stage]', box);
  const count = $('[data-lbox-count]', box);
  const hint = $('[data-lbox-hint]', box);
  const toque = matchMedia('(hover: none)').matches;
  hint.textContent = toque ? 'Toque na foto para aproximar' : 'Clique na foto para aproximar';
  box.classList.toggle('is-single', fotos.length < 2);
  let atual = 0;
  let voltar = null;

  const origem = (x, y) => {
    const r = img.getBoundingClientRect();
    const px = Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100));
    const py = Math.min(100, Math.max(0, ((y - r.top) / r.height) * 100));
    img.style.transformOrigin = `${px}% ${py}%`;
  };
  const zoom = (on, e) => {
    if (on && e) origem(e.clientX, e.clientY);
    box.classList.toggle('is-zoomed', on);
    hint.textContent = on ? (toque ? 'Arraste para ver os detalhes · toque para afastar' : 'Mova o mouse para ver os detalhes · clique para afastar') : (toque ? 'Toque na foto para aproximar' : 'Clique na foto para aproximar');
  };
  const mostrar = (i) => {
    atual = (i + fotos.length) % fotos.length;
    const s = fotos[atual];
    zoom(false);
    img.src = s.dataset.zoomSrc;
    img.width = Number(s.dataset.zoomW) || 1200;
    img.height = Number(s.dataset.zoomH) || 1200;
    const thumbImg = $('img', s);
    img.alt = thumbImg ? thumbImg.alt : '';
    count.textContent = `${atual + 1} / ${fotos.length}`;
    if (M) M.animate(img, { opacity: [0, 1] }, { duration: 0.28, ease: EASE });
  };
  const abrir = (i) => {
    voltar = document.activeElement;
    box.hidden = false;
    document.body.classList.add('is-locked');
    mostrar(i);
    if (M) M.animate(box, { opacity: [0, 1] }, { duration: 0.22 });
    $('[data-lbox-close]', box).focus({ preventScroll: true });
  };
  const fechar = () => {
    box.hidden = true;
    zoom(false);
    if (!$('.drawer.is-open, .search-overlay.is-open')) document.body.classList.remove('is-locked');
    if (voltar) voltar.focus({ preventScroll: true });
  };
  const indiceAtual = () => {
    const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    const k = fotos.indexOf(slides[i]);
    return k > -1 ? k : 0;
  };

  fotos.forEach((s) => s.addEventListener('click', () => abrir(fotos.indexOf(s))));
  const btn = $('[data-zoom-open]', root.closest('[data-product-section]') || document);
  if (btn) btn.addEventListener('click', () => abrir(indiceAtual()));
  // no toque, age ao levantar o dedo (depois de um arrasto o navegador pode não gerar o clique)
  let ultimoToque = 0;
  const aoTocar = (el, fn) => {
    el.addEventListener('pointerup', (e) => { if (e.pointerType !== 'mouse') { ultimoToque = Date.now(); fn(); } });
    el.addEventListener('click', () => { if (Date.now() - ultimoToque > 600) fn(); });
  };
  aoTocar($('[data-lbox-close]', box), fechar);
  aoTocar($('[data-lbox-prev]', box), () => mostrar(atual - 1));
  aoTocar($('[data-lbox-next]', box), () => mostrar(atual + 1));
  stage.addEventListener('click', (e) => { if (e.target === stage && !box.classList.contains('is-zoomed')) fechar(); });

  // clique/toque aproxima; arrastar com zoom move a foto; arrastar sem zoom troca de foto
  let inicio = null;
  let moveu = false;
  img.addEventListener('pointerdown', (e) => { inicio = { x: e.clientX, y: e.clientY }; moveu = false; img.setPointerCapture(e.pointerId); });
  img.addEventListener('pointermove', (e) => {
    if (box.classList.contains('is-zoomed') && (e.pointerType === 'mouse' || inicio)) origem(e.clientX, e.clientY);
    if (inicio && Math.hypot(e.clientX - inicio.x, e.clientY - inicio.y) > 8) moveu = true;
  });
  img.addEventListener('pointerup', (e) => {
    if (!inicio) return;
    const dx = e.clientX - inicio.x;
    inicio = null;
    if (!moveu) { zoom(!box.classList.contains('is-zoomed'), e); return; }
    if (!box.classList.contains('is-zoomed') && Math.abs(dx) > 50 && fotos.length > 1) mostrar(atual + (dx < 0 ? 1 : -1));
  });
  img.addEventListener('pointercancel', () => { inicio = null; });

  document.addEventListener('keydown', (e) => {
    if (box.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); if (box.classList.contains('is-zoomed')) zoom(false); else fechar(); }
    if (e.key === 'ArrowRight') mostrar(atual + 1);
    if (e.key === 'ArrowLeft') mostrar(atual - 1);
    if (e.key === 'Tab') {
      const itens = $$('button:not([hidden])', box).filter((b) => b.offsetParent);
      const i = itens.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); itens[itens.length - 1].focus(); }
      else if (!e.shiftKey && i === itens.length - 1) { e.preventDefault(); itens[0].focus(); }
    }
  });
}

$$('[data-product-section]').forEach(initProduct);

/* ---------------- Reels ---------------- */
function initReels(root) {
  // setas no computador e degradê na borda que ainda tem vídeo
  const wrap = $('[data-reels-wrap]', root);
  const trilho = $('[data-reels-track]', root);
  if (wrap && trilho) {
    const atualizar = () => {
      const prev = trilho.scrollLeft > 4;
      const next = trilho.scrollLeft + trilho.clientWidth < trilho.scrollWidth - 4;
      wrap.classList.toggle('has-prev', prev);
      wrap.classList.toggle('has-next', next);
      $$('[data-reels-scroll]', wrap).forEach((b) => { b.hidden = b.dataset.reelsScroll === '1' ? !next : !prev; });
    };
    $$('[data-reels-scroll]', wrap).forEach((b) => b.addEventListener('click', () => {
      const card = $('.reel', trilho);
      const passo = card ? (card.offsetWidth + 10) * Math.max(1, Math.floor(trilho.clientWidth / (card.offsetWidth + 10)) - 1) : trilho.clientWidth * 0.8;
      trilho.scrollBy({ left: passo * Number(b.dataset.reelsScroll), behavior: reduceMotion ? 'auto' : 'smooth' });
    }));
    trilho.addEventListener('scroll', atualizar, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(atualizar).observe(trilho);
    atualizar();
  }
  const reels = $$('[data-reel]', root).filter((r) => r.dataset.src);
  const modal = $('[data-reels-modal]', root);
  if (!reels.length || !modal) return;
  const player = $('[data-reels-video]', modal);
  const cta = $('[data-reels-cta]', modal);
  modal.classList.toggle('is-single', reels.length < 2);
  let atual = 0;
  let voltar = null;

  // prévia sem som ao passar o mouse
  if (matchMedia('(hover: hover)').matches) {
    reels.forEach((r) => {
      const v = $('video', r);
      if (!v) return;
      r.addEventListener('mouseenter', () => { v.muted = true; v.play().catch(() => {}); });
      r.addEventListener('mouseleave', () => { v.pause(); });
    });
  }

  const mostrar = (i) => {
    atual = (i + reels.length) % reels.length;
    const r = reels[atual];
    player.poster = r.dataset.poster || '';
    player.src = r.dataset.src;
    player.muted = false;
    player.play().catch(() => { player.muted = true; player.play().catch(() => {}); });
    if (r.dataset.produtoUrl) { cta.href = r.dataset.produtoUrl; cta.hidden = false; $('span', cta).textContent = 'Ver produto'; cta.setAttribute('aria-label', `Ver ${r.dataset.produtoNome}`); }
    else cta.hidden = true;
  };
  const abrir = (i) => {
    voltar = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('is-locked');
    reels.forEach((r) => { const v = $('video', r); if (v) v.pause(); });
    mostrar(i);
    if (M) M.animate(modal, { opacity: [0, 1] }, { duration: 0.22 });
    $('[data-reels-close]', modal).focus({ preventScroll: true });
  };
  const fechar = () => {
    player.pause();
    player.removeAttribute('src');
    player.load();
    modal.hidden = true;
    if (!$('.drawer.is-open, .search-overlay.is-open')) document.body.classList.remove('is-locked');
    if (voltar) voltar.focus({ preventScroll: true });
  };

  reels.forEach((r, i) => $('[data-reel-open]', r).addEventListener('click', () => abrir(i)));
  $('[data-reels-close]', modal).addEventListener('click', fechar);
  $('[data-reels-prev]', modal).addEventListener('click', () => mostrar(atual - 1));
  $('[data-reels-next]', modal).addEventListener('click', () => mostrar(atual + 1));
  modal.addEventListener('click', (e) => { if (e.target === modal) fechar(); });
  document.addEventListener('keydown', (e) => {
    if (modal.hidden) return;
    if (e.key === 'Escape') fechar();
    if (e.key === 'ArrowRight') mostrar(atual + 1);
    if (e.key === 'ArrowLeft') mostrar(atual - 1);
  });
}
$$('[data-reels]').forEach(initReels);
document.addEventListener('shopify:section:load', (e) => $$('[data-reels]', e.target).forEach(initReels));

/* ---------------- Recomendações ---------------- */
$$('[data-recs]').forEach(async (el) => {
  if (el.children.length && $('.rail', el)) return;
  try {
    const html = await (await fetch(el.dataset.url)).text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-recs]');
    if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; initRails(el); revealIn(el); }
  } catch (err) { /* sem recomendações, sem seção */ }
});

/* ---------------- Trilhos ---------------- */
function initRails(scope = document) {
  $$('[data-rail]', scope).forEach((rail) => {
    const host = rail.closest('section, .dores__panel') || rail.parentElement;
    const prev = $('[data-rail-prev]', host);
    const next = $('[data-rail-next]', host);
    if (!prev || !next || prev._bound) return;
    prev._bound = true;
    const step = () => (rail.firstElementChild ? rail.firstElementChild.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8);
    const update = () => {
      prev.disabled = rail.scrollLeft < 4;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
    };
    prev.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: 'smooth' }));
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });
}
initRails();

/* ---------------- Banners do topo ---------------- */
$$('[data-hero]').forEach((hero) => {
  const track = $('[data-hero-track]', hero);
  const dots = $$('[data-hero-dot]', hero);
  const slides = [...track.children];
  if (slides.length < 2) return;
  let i = 0;
  const go = (k) => { i = (k + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' }); };
  track.addEventListener('scroll', () => {
    const k = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    i = k;
    dots.forEach((d, n) => d.setAttribute('aria-current', n === k ? 'true' : 'false'));
  }, { passive: true });
  dots.forEach((d) => d.addEventListener('click', () => { go(Number(d.dataset.heroDot)); restart(); }));
  const prev = $('[data-hero-prev]', hero);
  const next = $('[data-hero-next]', hero);
  prev && prev.addEventListener('click', () => { go(i - 1); restart(); });
  next && next.addEventListener('click', () => { go(i + 1); restart(); });
  const secs = Number(hero.dataset.autoplay || ($('[data-hero-dots]', hero) || {}).dataset?.autoplay || 0);
  let timer;
  function restart() {
    clearInterval(timer);
    if (!secs || reduceMotion) return;
    timer = setInterval(() => { if (!document.hidden && !hero.matches(':hover')) go(i + 1); }, secs * 1000);
  }
  restart();
});

/* ---------------- Seletor de dores ---------------- */
$$('[data-dores]').forEach((root) => {
  const tabs = $$('[data-dor-tab]', root);
  const panels = $$('[data-dor-panel]', root);
  let busy = false;
  async function select(tab) {
    if (busy || tab.getAttribute('aria-selected') === 'true') return;
    busy = true;
    const next = document.getElementById(tab.getAttribute('aria-controls'));
    const prevPanel = panels.find((p) => !p.hidden);
    tabs.forEach((t) => { const on = t === tab; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; });
    if (M && prevPanel) {
      await M.animate($$('.card, .dores__pitch', prevPanel), { opacity: 0, y: -10, filter: 'blur(4px)' }, { duration: 0.18, ease: 'easeIn' }).finished;
      $$('.card, .dores__pitch', prevPanel).forEach((el) => { el.style.opacity = ''; el.style.transform = ''; el.style.filter = ''; });
    }
    panels.forEach((p) => { p.hidden = p !== next; });
    const rail = $('[data-rail]', next);
    if (rail) rail.scrollLeft = 0;
    initRails(next);
    if (M) {
      M.animate($('.dores__pitch', next), { opacity: [0, 1], x: [-24, 0] }, { duration: 0.5, ease: EASE });
      M.animate($$('.card', next), { opacity: [0, 1], y: [36, 0], scale: [0.94, 1] }, { delay: M.stagger(0.06, { startDelay: 0.08 }), type: 'spring', stiffness: 260, damping: 22 });
      M.animate($('.dor-tab__ico', tab), { rotate: [0, -14, 10, 0], scale: [1, 1.18, 1] }, { duration: 0.55, ease: EASE });
    }
    busy = false;
  }
  tabs.forEach((tab, idx) => {
    tab.addEventListener('click', () => select(tab));
    tab.addEventListener('keydown', (e) => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      const t = tabs[(idx + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
      t.focus();
      select(t);
    });
  });
});

/* ---------------- Cookies ---------------- */
const cookies = $('[data-cookies]');
if (cookies) {
  let seen = null;
  try { seen = localStorage.getItem('ricapet_cookies'); } catch (e) { seen = '1'; }
  if (!seen) setTimeout(() => cookies.classList.add('is-visible'), 1200);
  const ok = $('[data-cookies-ok]', cookies);
  ok && ok.addEventListener('click', () => {
    try { localStorage.setItem('ricapet_cookies', '1'); } catch (e) { /* navegação privada */ }
    cookies.classList.remove('is-visible');
  });
}

/* ---------------- Formulário do carrinho (página) ---------------- */
const cartForm = $('#cart-form');
if (cartForm) {
  cartForm.addEventListener('submit', (e) => {
    const submitter = e.submitter;
    if (submitter && submitter.name === 'checkout' && !submitter.classList.contains('ymp_elem_mainBtn')) {
      // Se o script da Yampi não substituiu o botão, levamos direto para o checkout dela.
      e.preventDefault();
      goCheckout(submitter);
    }
  });
}

/* ---------------- Movimento ---------------- */
function splitWords(el) {
  if (el._split) return $$('.w', el);
  el._split = true;
  const walk = (node) => {
    [...node.childNodes].forEach((n) => {
      if (n.nodeType === 3) {
        const frag = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach((part) => {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
          const s = document.createElement('span');
          s.className = 'w';
          s.style.display = 'inline-block';
          s.textContent = part;
          frag.appendChild(s);
        });
        n.replaceWith(frag);
      } else if (n.nodeType === 1) walk(n);
    });
  };
  walk(el);
  return $$('.w', el);
}

function revealIn(scope = document) {
  if (!M) return;
  const below = (el) => el.getBoundingClientRect().top > window.innerHeight * 0.92;
  const groups = $$('.section-head, .grid-products, .rail, .cats, .promos, .perks, .insta, .faq, .news, .fabrica__grid, .blog-grid', scope)
    .filter((g) => !g._revealed && below(g));
  groups.forEach((g) => {
    g._revealed = true;
    const items = g.matches('.section-head') ? [...g.children]
      : g.matches('.fabrica__grid') ? $$('.fabrica__fact, .fabrica__media, .fabrica__lead, .btn', g)
      : g.matches('.faq') ? $$('.faq__intro, .acc', g)
      : [...g.children];
    if (!items.length) return;
    items.forEach((el) => { el.style.opacity = '0'; });
    M.inView(g, () => {
      M.animate(items, { opacity: [0, 1], y: [28, 0], filter: ['blur(6px)', 'blur(0px)'] }, { delay: M.stagger(0.07), duration: 0.7, ease: EASE })
        .then(() => items.forEach((el) => { el.style.filter = ''; }));
      return () => {};
    }, { amount: 0.15 });
  });
  $$('.fabrica [data-split]', scope).forEach((h) => {
    if (h._splitDone || !below(h)) return;
    h._splitDone = true;
    const words = splitWords(h);
    words.forEach((w) => { w.style.opacity = '0'; });
    M.inView(h, () => {
      M.animate(words, { opacity: [0, 1], y: ['0.5em', '0em'], rotate: [4, 0] }, { delay: M.stagger(0.06), type: 'spring', stiffness: 220, damping: 20 });
    }, { amount: 0.4 });
  });
}

motionReady.then(() => {
  if (!M) return;
  revealIn();
  const paw = $('.free-ship__paw');
  if (paw) M.animate(paw, { rotate: [0, -12, 12, 0] }, { duration: 1.2, repeat: Infinity, repeatDelay: 2.4 });
});
